module.exports = __webpack_public_path__ + "static/es-logo100-web-black-2beadd75fe07535160ef6eb5f2be4952.svg";